<template>
  <div>
    <v-container>
      <h1 class="primary--text font-weight-bold pb-4">
        {{
          isEditArea
            ? $t("settings.area.updateArea")
            : $t("settings.area.newArea")
        }}
      </h1>
      <ValidationObserver ref="observer" v-slot="{ handleSubmit, valid }">
        <form v-on:submit.prevent="handleSubmit(onSave)" :key="reRender">
          <div
            class="tw-w-full tw-grid tw-gap-x-4 tw-grid-cols-1 lg:tw-grid-cols-2"
          >
            <div>
              <ValidationProvider
                v-slot="{ errors }"
                rules="required"
                :name="$t('settings.area.name') + $t('common.en')"
              >
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  :label="`${$t('settings.area.name')} (${$t('common.en')})`"
                  color="secondary"
                  type="text"
                  v-model="areaModelObj.nameEn"
                  ><template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("settings.area.name") }} ({{ $t("common.en") }})
                  </template>
                </v-text-field>
              </ValidationProvider>
            </div>
            <div>
              <ValidationProvider
                v-slot="{ errors }"
                rules="required|arabicText"
                :name="$t('settings.area.name') + $t('common.ar')"
              >
                <v-text-field
                  outlined
                  :error-messages="errors"
                  dense
                  :label="`${$t('settings.area.name')} (${$t('common.ar')})`"
                  color="secondary"
                  type="text"
                  v-model="areaModelObj.nameAr"
                >
                  <template #label>
                    <span class="red--text"><strong>* </strong></span
                    >{{ $t("settings.area.name") }} ({{ $t("common.ar") }})
                  </template>
                </v-text-field>
              </ValidationProvider>
            </div>
            <!-- <v-col cols="12" sm="6" md="6" class="py-0 pt-6">
                <ValidationProvider v-slot="{ errors }" rules="required">
                <v-autocomplete
                  outlined
                  :error-messages="errors"
                  dense
                  :label="`${$t('settings.area.name')} (${$t('common.ar')})`"
                  color="secondary"
                  type="text"
                  v-model="areaModelObj.countryCode"
                  :items="countriesList"
                  item-text="name"
                  item-value="code"
                >
                <template #label>
                <span>
                  <strong class="red--text">* </strong>
                  <span>{{ $t('settings.area.selectCountry') }}</span>
                </span>
                </template>
                </v-autocomplete>
              </ValidationProvider>
            </v-col> -->
            <template
              align="center"
              v-for="(item, index) in areaModelObj.subAreas"
            >
              <v-col
                cols="12"
                sm="5"
                md="5"
                class="py-0 pt-6"
                :key="`${index}_nameEn`"
              >
                <ValidationProvider v-slot="{ errors }" rules="required">
                  <v-text-field
                    outlined
                    :error-messages="errors"
                    dense
                    :label="`${$t('settings.area.name')} (${$t('common.en')})`"
                    color="secondary"
                    type="text"
                    v-model="item.nameEn"
                  >
                  </v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col
                cols="12"
                sm="5"
                md="5"
                class="py-0 pt-6"
                :key="`${index}_nameAr`"
              >
                <ValidationProvider v-slot="{ errors }" rules="required">
                  <v-text-field
                    outlined
                    :error-messages="errors"
                    dense
                    :label="`${$t('settings.area.name')} (${$t('common.ar')})`"
                    color="secondary"
                    type="text"
                    v-model="item.nameAr"
                  >
                  </v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" sm="2" md="2" :key="`${index}_deleteBtn`">
                <v-btn
                  depressed
                  text
                  color="primary "
                  class="font-weight-bold"
                  x-small
                  @click="deleteSubArea(index)"
                >
                  <v-icon left>mdi-delete</v-icon>
                </v-btn>
              </v-col>
            </template>
            <!-- <v-col class="mt-n6" cols="12" sm="12" md="12" align="right">
              <v-btn
                depressed
                text
                color="primary"
                class="font-weight-bold text-none"
                x-small
                @click="addSubAreas"
              >
                <v-icon left small>mdi-plus</v-icon>
                {{ $t("settings.area.addSubArea") }}
              </v-btn>
            </v-col> -->
          </div>
          <div class=" tw-flex tw-w-full tw-justify-end">
            <!-- <div class="d-flex justify-space-around"> -->
            <!-- <v-btn class="custom-button text-none" @click="onCancel">
               {{ $t('common.cancel')}}
               </v-btn> -->
            <v-btn
              width="20%"
              :disabled="!valid"
              class="white--text rounded-lg"
              color="primary"
              type="submit"
              :loading="btnLoading"
            >
              {{ isEditArea ? $t("common.update") : $t("common.save") }}
            </v-btn>
            <!-- </div> -->
          </div>
          <v-col v-if="isError != null" cols="12" sm="12"
            ><Alert :message="isError" />
          </v-col>
        </form>
      </ValidationObserver>
    </v-container>
  </div>
</template>
<script>
import "@/core/methods/validation_rules";
import { mapGetters } from "vuex";
import { getCountries } from "../../methods/area/country_list";
import { createGovernate } from "../../methods/governate/create_governate";
import { updateGovernate } from "../../methods/governate/update_governate";
export default {
  data() {
    return {
      reRender: 0,
      btnLoading: false,
      areaModelObj: {
        nameAr: "",
        nameEn: ""
        // countryCode: ""
        // subAreas: []
      },
      isError: null
    };
  },
  components: {
    Alert: () => import("@/core/components/Alert.vue")
  },
  mounted() {
    if (this.isEditArea)
      this.areaModelObj = this.$format.cloneVariable(this.editArea);
  },
  computed: {
    ...mapGetters(["isEditArea", "editArea"]),
    countriesList() {
      return getCountries();
    }
  },
  watch: {
    isEditArea: {
      handler() {
        if (this.isEditArea) {
          this.areaModelObj = this.$format.cloneVariable(this.editArea);
        } else {
          this.areaModelObj = {
            nameAr: "",
            nameEn: ""
            // countryCode: ""
            // subAreas: []
          };
          this.reRender++;
        }
      },
      deep: true
    }
  },
  methods: {
    addSubAreas() {
      this.areaModelObj.subAreas.push({ nameEn: "", nameAr: "" });
    },
    deleteSubArea(index) {
      this.areaModelObj.subAreas.splice(index, 1);
    },
    async onSave() {
      this.btnLoading = true;
      const input = {
        input: this.$format.cloneVariable(this.areaModelObj)
      };
      if (!this.isEditArea) {
        createGovernate(input).then(response => {
          if (response.data) {
            this.btnLoading = false;
            this.$root.$emit("refetchArea");
            this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
            this.$root.$emit("snackbar", {
              snackbar: true,
              text: this.$t("common.saveSuccess"),
              color: "green"
            });
            this.areaModelObj = {};
            this.reRender++;
          }
          if (response.graphQLErrors) {
            this.btnLoading = false;
            this.isError = response.graphQLErrors[0].message;
            setTimeout(() => {
              this.isError = null;
            }, 5000);
          }
        });
      } else {
        // comment for temprary ... this is for subAreas
        // const subAreas = input.input.subAreas.map(item => {
        //   return {
        //     nameEn: item.nameEn,
        //     nameAr: item.nameAr
        //   }
        // })
        const updateInput = {
          id: input.input._id,
          input: {
            nameEn: input.input.nameEn,
            nameAr: input.input.nameAr
            // countryCode: input.input.countryCode
            // subAreas: subAreas ? subAreas : {}
          }
        };
        updateGovernate(updateInput).then(response => {
          if (response.data) {
            this.$root.$emit("refetchArea");
            this.btnLoading = false;
            this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
            this.$store.commit("IS_EDIT_AREA", false);
            this.$root.$emit("snackbar", {
              snackbar: true,
              text: this.$t("common.updateSuccess"),
              color: "green"
            });
          }
          if (response.graphQLErrors) {
            this.btnLoading = false;
            this.isError = response.graphQLErrors[0].message;
          }
        });
      }
    },
    onCancel() {
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", false);
      this.$store.commit("IS_EDIT_AREA", false);
    }
  }
};
</script>
